import React from "react";
import Layout from "../../../components/layout/layout";
import { LeadsPage } from "../../../components/leads/leads-page";

export default function LeadContacts({ component, ...rest }) {
  return <Layout Component={ LeadsPage } controlsDisabled={true} {...rest} />;
}
